import { render, staticRenderFns } from "./DocsTahazzar.vue?vue&type=template&id=05cc18a7&"
import script from "./DocsTahazzar.vue?vue&type=script&lang=js&"
export * from "./DocsTahazzar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports